/* Dirty Penny — Bundle Builder engine (sections/dp-bundle-builder.liquid).
   Figma 1314-15558 (desktop filled) + 775-7750/7899/7796/7662 (filter drawer).

   State: { [variantId]: { qty, handle, title, meta, price, img, cap } }
   persisted in localStorage (dpBundle_v1) so an in-progress bundle survives
   navigation. Tier discounts are DISPLAY math mirroring the store's
   quantity-based automatic discounts (checkout applies the real one) —
   quantities count toward tiers, same as Shopify's counting.
   ADD BUNDLE TO CART = one cart/add.js POST with a sections payload handed
   to the theme's (dp-cart-patched) reRenderSections, then the drawer opens
   via the same store calls dp-cart.js uses. Pre-built bundles post their
   items the same way without touching builder state. */
(function () {
  'use strict';
  if (window.__dpBundleBuilder) { window.__dpBundleBuilder(); return; }

  var LS_KEY = 'dpBundle_v1';

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function init(root) {
    if (root.hasAttribute('data-bb-ready')) return;
    root.setAttribute('data-bb-ready', '');

    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
    tiers.sort(function (a, b) { return a.n - b.n; });

    var state = {};
    try {
      var saved = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      if (saved && typeof saved === 'object') state = saved;
    } catch (e) {}

    /* the sticky mini bar only lives while the section is on screen */
    var barInView = false;

    var rail = {
      count: root.querySelector('[data-bb-count]'),
      applied: root.querySelector('[data-bb-applied]'),
      helper: root.querySelector('[data-bb-helper]'),
      fill: root.querySelector('[data-bb-tierfill]'),
      items: root.querySelector('[data-bb-items]'),
      empty: root.querySelector('[data-bb-empty]'),
      emptyCopy: root.querySelector('[data-bb-emptycopy]'),
      selectedLabel: root.querySelector('[data-bb-selectedlabel]'),
      nudge: root.querySelector('[data-bb-nudge]'),
      nudgeTitle: root.querySelector('[data-bb-nudge-title]'),
      nudgeMain: root.querySelector('[data-bb-nudge-main]'),
      nudgeSub: root.querySelector('[data-bb-nudge-sub]'),
      subtotal: root.querySelector('[data-bb-subtotal]'),
      savingsRow: root.querySelector('[data-bb-savings-row]'),
      savings: root.querySelector('[data-bb-savings]'),
      total: root.querySelector('[data-bb-total]'),
      atc: root.querySelector('[data-bb-atc]'),
      rowTpl: root.querySelector('template[data-bb-row-template]'),
      bar: root.querySelector('[data-bb-mobilebar]'),
      barCount: root.querySelector('[data-bb-mbar-count]'),
      barTotal: root.querySelector('[data-bb-mbar-total]')
    };

    /* ---------------- state helpers ---------------- */
    function persist() {
      try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {}
    }
    function totalQty() {
      var n = 0;
      for (var k in state) n += state[k].qty;
      return n;
    }
    function subtotalCents() {
      var n = 0;
      for (var k in state) n += state[k].qty * state[k].price;
      return n;
    }
    function currentTier(qty) {
      var cur = null;
      for (var i = 0; i < tiers.length; i++) if (qty >= tiers[i].n) cur = tiers[i];
      return cur;
    }
    function nextTier(qty) {
      for (var i = 0; i < tiers.length; i++) if (qty < tiers[i].n) return tiers[i];
      return null;
    }

    /* ---------------- rail render ---------------- */
    function renderRail() {
      var qty = totalQty();
      var sub = subtotalCents();
      var cur = currentTier(qty);
      var nxt = nextTier(qty);
      var pct = cur ? cur.pct : 0;
      var savings = Math.round(sub * pct / 100);

      if (rail.count) rail.count.textContent = qty + (qty === 1 ? ' item' : ' items');
      if (rail.applied) {
        rail.applied.textContent = cur ? cur.pct + '% off applied' : '';
        rail.applied.hidden = !cur;
      }
      if (rail.helper) {
        if (qty === 0 && tiers.length) {
          rail.helper.textContent = 'Add at least ' + tiers[0].n + ' items to reach ' + tiers[0].pct + '% off';
        } else if (nxt) {
          rail.helper.textContent = 'Add ' + (nxt.n - qty) + ' more ' + (nxt.n - qty === 1 ? 'item' : 'items') + ' to reach ' + nxt.pct + '% off';
        } else if (cur) {
          rail.helper.textContent = 'Maximum savings unlocked';
        }
      }
      if (rail.emptyCopy && tiers.length) {
        rail.emptyCopy.textContent = 'Add at least ' + tiers[0].n + ' items to unlock ' + tiers[0].pct + '% off' +
          (tiers[1] ? ' or add ' + tiers[1].n + '+ items to unlock ' + tiers[1].pct + '% off.' : '.');
      }
      if (rail.selectedLabel) rail.selectedLabel.hidden = qty === 0;

      /* tier track: fill to the exact progress point between dots */
      if (rail.fill && tiers.length) {
        var frac = 0;
        var last = tiers[tiers.length - 1];
        if (qty >= last.n) frac = 1;
        else {
          /* dots sit at even fractions across the track */
          var prevN = 0, prevPos = 0;
          for (var i = 0; i < tiers.length; i++) {
            var pos = (i + 1) / tiers.length;
            if (qty < tiers[i].n) {
              frac = prevPos + (qty - prevN) / (tiers[i].n - prevN) * (pos - prevPos);
              break;
            }
            prevN = tiers[i].n; prevPos = pos;
          }
        }
        rail.fill.style.width = (frac * 100).toFixed(1) + '%';
      }
      root.querySelectorAll('[data-bb-tier-i]').forEach(function (dot) {
        var i = +dot.getAttribute('data-bb-tier-i');
        var reached = tiers[i] && qty >= tiers[i].n;
        dot.classList.toggle('is-reached', reached);
        /* the highest reached tier is the CURRENT one — it pulses */
        dot.classList.toggle('is-current', reached && cur === tiers[i]);
      });

      /* items list (rebuild preserves the list's scroll position) */
      if (rail.items && rail.rowTpl) {
        var keepScroll = rail.items.scrollTop;
        rail.items.innerHTML = '';
        var keys = Object.keys(state);
        keys.forEach(function (vid) {
          var it = state[vid];
          var row = rail.rowTpl.content.firstElementChild.cloneNode(true);
          row.setAttribute('data-vid', vid);
          var img = row.querySelector('[data-r-img]');
          if (img) { if (it.img) img.src = it.img; else img.remove(); }
          row.querySelector('[data-r-title]').textContent = it.title;
          row.querySelector('[data-r-meta]').textContent = it.meta || '';
          row.querySelector('[data-r-qty]').textContent = it.qty;
          row.querySelector('[data-r-price]').textContent = money(it.qty * it.price);
          var plus = row.querySelector('[data-r-plus]');
          if (plus && it.qty >= (it.cap || 99)) plus.disabled = true;
          rail.items.appendChild(row);
        });
        rail.items.scrollTop = keepScroll;
        if (rail.empty) rail.empty.hidden = keys.length > 0;
      }

      /* an emptied bundle is a fresh start — used pre-built cards return */
      if (qty === 0) {
        root.querySelectorAll('.dp-bb-pb.is-used').forEach(function (pbEl) {
          pbEl.classList.remove('is-used');
          pbEl.style.display = '';
        });
        updateCarousel(root.querySelector('.dp-bb-pbwrap'));
      }

      /* next-tier nudge / terminal state */
      if (rail.nudge) {
        rail.nudge.hidden = qty === 0;
        if (nxt) {
          rail.nudge.classList.remove('is-max');
          if (rail.nudgeTitle) rail.nudgeTitle.textContent = 'Next tier';
          if (rail.nudgeMain) rail.nudgeMain.textContent = nxt.n + ' items to unlock ' + nxt.pct + '% off';
          if (rail.nudgeSub) rail.nudgeSub.textContent = 'Add ' + (nxt.n - qty) + ' more ' + (nxt.n - qty === 1 ? 'item' : 'items');
        } else if (cur) {
          rail.nudge.classList.add('is-max');
          if (rail.nudgeTitle) rail.nudgeTitle.textContent = 'Top tier';
          if (rail.nudgeMain) rail.nudgeMain.textContent = 'Maximum savings applied';
          if (rail.nudgeSub) rail.nudgeSub.textContent = cur.pct + '% off your bundle';
        }
      }

      if (rail.subtotal) rail.subtotal.textContent = money(sub);
      if (rail.savingsRow) rail.savingsRow.hidden = savings <= 0;
      if (rail.savings) rail.savings.textContent = '-' + money(savings);
      if (rail.total) rail.total.textContent = money(sub - savings);
      if (rail.atc) rail.atc.disabled = qty === 0;

      if (rail.bar) {
        rail.bar.classList.toggle('is-on', qty > 0 && barInView);
        if (rail.barCount) {
          rail.barCount.textContent = qty + (qty === 1 ? ' item' : ' items') + (cur ? ' - ' + cur.pct + '% off applied' : '');
        }
        if (rail.barTotal) rail.barTotal.textContent = money(sub - savings);
      }

      syncCards();
    }

    /* card footers mirror state (ADD vs ADDED+stepper) */
    function syncCards() {
      root.querySelectorAll('.dp-bb-card').forEach(function (card) {
        var vid = card.getAttribute('data-vid');
        var it = state[vid];
        var added = card.querySelector('.dp-bb-added');
        var add = card.querySelector('.dp-bb-add');
        if (!added || !add) return;
        if (it) {
          add.hidden = true;
          added.hidden = false;
          var q = added.querySelector('[data-c-qty]');
          if (q) q.textContent = it.qty;
          var plus = added.querySelector('[data-c-plus]');
          if (plus) plus.disabled = it.qty >= (it.cap || 99);
        } else {
          add.hidden = false;
          added.hidden = true;
        }
        card.classList.toggle('is-added', !!it);
      });
    }

    function itemFromCard(card) {
      return {
        qty: 0,
        handle: card.getAttribute('data-handle'),
        title: card.getAttribute('data-title'),
        meta: card.getAttribute('data-meta'),
        price: +card.getAttribute('data-price') || 0,
        img: card.getAttribute('data-img') || '',
        cap: +card.getAttribute('data-cap') || 99
      };
    }

    function bump(vid, delta, seed) {
      var it = state[vid];
      if (!it && delta > 0 && seed) { it = seed; state[vid] = it; }
      if (!it) return;
      it.qty = Math.min(it.qty + delta, it.cap || 99);
      if (it.qty <= 0) delete state[vid];
      persist();
      renderRail();
    }

    /* ---------------- filters (dynamic per category tab) ----------------
       Each tab declares a filter PRESET (which drawer groups apply) and an
       optional disabled-options list; filter state is kept per tab. */
    var PRESET_GROUPS = {
      'edibles': ['strength', 'effect', 'cann'],
      'weight-strain': ['weight', 'strain'],
      'strain': ['strain'],
      'none': []
    };
    var STRENGTH_ALIAS = {
      microdose: ['micro', 'microdose', 'low'],
      medium: ['medium', 'med'],
      high: ['high']
    };
    var tabFilters = {};

    function activePanel() {
      return root.querySelector('.dp-bb-panel:not([hidden])');
    }
    function panelPreset(panel) {
      var p = panel.getAttribute('data-fpreset') || 'edibles';
      return PRESET_GROUPS[p] ? p : 'edibles';
    }
    function panelDisabled(panel) {
      return (panel.getAttribute('data-fdisabled') || '')
        .toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    function stateFor(panel) {
      var i = panel.getAttribute('data-panel-i');
      if (!tabFilters[i]) tabFilters[i] = { strength: '', effect: [], cann: [], weight: [], strain: [] };
      return tabFilters[i];
    }

    function cardMatchesFilters(card, f) {
      if (f.strength) {
        var pot = (card.getAttribute('data-pot') || '').toLowerCase();
        if (STRENGTH_ALIAS[f.strength].indexOf(pot) === -1) return false;
      }
      if (f.effect.length) {
        /* effects can be multi-valued ("social, focus") */
        var effs = (card.getAttribute('data-eff') || '').toLowerCase()
          .split(',').map(function (s) { return s.trim(); });
        var effHit = f.effect.some(function (e) { return effs.indexOf(e) !== -1; });
        if (!effHit) return false;
      }
      if (f.cann.length) {
        var cann = ' ' + (card.getAttribute('data-cann') || '').toLowerCase() + ' ';
        var hit = f.cann.some(function (c) { return cann.indexOf(' ' + c + ' ') !== -1; });
        if (!hit) return false;
      }
      if (f.weight.length) {
        if (f.weight.indexOf((card.getAttribute('data-weight') || '').toLowerCase()) === -1) return false;
      }
      if (f.strain.length) {
        if (f.strain.indexOf((card.getAttribute('data-strain') || '').toLowerCase()) === -1) return false;
      }
      return true;
    }

    function filterCount(f) {
      return (f.strength ? 1 : 0) + f.effect.length + f.cann.length + f.weight.length + f.strain.length;
    }

    /* drawer mirrors the ACTIVE tab: group visibility, disabled options,
       input states, group counters */
    function syncFilterUI() {
      var panel = activePanel();
      if (!panel || !fdrawer) return;
      var groups = PRESET_GROUPS[panelPreset(panel)];
      var disabled = panelDisabled(panel);
      var f = stateFor(panel);
      root.querySelectorAll('.dp-bb-fgroup').forEach(function (g) {
        var key = g.getAttribute('data-fgroup');
        g.hidden = groups.indexOf(key) === -1;
        var n = key === 'strength' ? (f.strength ? 1 : 0) : (f[key] || []).length;
        var c = g.querySelector('[data-fg-count]');
        if (c) c.textContent = n ? ' (' + n + ')' : '';
      });
      fdrawer.querySelectorAll('input[name="bb-strength"]').forEach(function (i) { i.checked = f.strength === i.value; });
      fdrawer.querySelectorAll('input[name="bb-effect"]').forEach(function (i) { i.checked = f.effect.indexOf(i.value) !== -1; });
      fdrawer.querySelectorAll('input[name="bb-cann"]').forEach(function (i) { i.checked = f.cann.indexOf(i.value) !== -1; });
      fdrawer.querySelectorAll('input[name="bb-weight"]').forEach(function (i) { i.checked = f.weight.indexOf(i.value) !== -1; });
      fdrawer.querySelectorAll('input[name="bb-strain"]').forEach(function (i) {
        var off = disabled.indexOf(i.value) !== -1;
        i.disabled = off;
        if (off) i.checked = false;
        else i.checked = f.strain.indexOf(i.value) !== -1;
        var opt = i.closest('.dp-bb-fopt');
        if (opt) opt.classList.toggle('is-disabled', off);
      });
    }

    /* sub-category chips match a product TYPE, a TAG, or a WEIGHT
       (e.g. "Dog Walkers | 0.5g" — a dog walker IS a half-gram pre-roll) */
    function cardMatchesChip(card, val) {
      if (val === 'all') return true;
      if (card.getAttribute('data-ptype') === val) return true;
      if ((card.getAttribute('data-weight') || '') === val) return true;
      var tags = (card.getAttribute('data-tags') || '').split('|');
      return tags.indexOf(val) !== -1;
    }

    function applyVisibility() {
      root.querySelectorAll('.dp-bb-panel').forEach(function (panel) {
        var chip = panel.querySelector('.dp-bb-chip.is-active');
        var type = chip ? chip.getAttribute('data-type') : 'all';
        var f = stateFor(panel);
        var any = 0;
        panel.querySelectorAll('.dp-bb-card').forEach(function (card) {
          var show = cardMatchesChip(card, type) && cardMatchesFilters(card, f);
          card.hidden = !show;
          if (show) any++;
        });
        /* an EMPTY category (no purchasable products at all) reads
           differently from filters excluding everything */
        var totalCards = panel.querySelectorAll('.dp-bb-card').length;
        var none = panel.querySelector('[data-bb-none]');
        if (none) {
          none.hidden = any > 0;
          none.textContent = totalCards === 0
            ? (none.getAttribute('data-msg-empty') || none.textContent)
            : (none.getAttribute('data-msg-filtered') || none.textContent);
        }
        /* per-panel FILTER link: badge from this tab's state, hidden when
           the tab has no filter set — or nothing to filter */
        var link = panel.querySelector('.dp-bb-filterlink');
        if (link) {
          link.hidden = panelPreset(panel) === 'none' || totalCards === 0;
          var fc = link.querySelector('[data-bb-fcount]');
          if (fc) {
            var n = filterCount(f);
            fc.textContent = n ? ' (' + n + ')' : '';
          }
        }
        updateCarousel(panel);
      });
      syncFilterUI();
    }

    function readFilterInputs() {
      var panel = activePanel();
      if (!panel) return;
      var f = stateFor(panel);
      var disabled = panelDisabled(panel);
      var s = root.querySelector('input[name="bb-strength"]:checked');
      f.strength = s ? s.value : '';
      f.effect = [].map.call(root.querySelectorAll('input[name="bb-effect"]:checked'), function (i) { return i.value; });
      f.cann = [].map.call(root.querySelectorAll('input[name="bb-cann"]:checked'), function (i) { return i.value; });
      f.weight = [].map.call(root.querySelectorAll('input[name="bb-weight"]:checked'), function (i) { return i.value; });
      f.strain = [].map.call(root.querySelectorAll('input[name="bb-strain"]:checked'), function (i) { return i.value; })
        .filter(function (v) { return disabled.indexOf(v) === -1; });
    }

    var fdrawer = root.querySelector('[data-bb-fdrawer]');
    var foverlay = root.querySelector('[data-bb-foverlay]');
    function setFilterOpen(open) {
      if (!fdrawer) return;
      fdrawer.classList.toggle('is-open', open);
      if (foverlay) foverlay.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('dp-bb-filter-open', open);
    }

    /* ---------------- carousels (product tracks + prebuilt row) ---------------- */
    function carWrapper(el) {
      return el.closest('.dp-bb-panel') || el.closest('.dp-bb-pbwrap');
    }
    function updateCarousel(wrap) {
      if (!wrap) return;
      var track = wrap.querySelector('[data-bb-scroller]');
      if (!track) return;
      var bar = wrap.querySelector('.dp-bb-progress i');
      var max = track.scrollWidth - track.clientWidth;
      if (bar) {
        var w = max > 4 ? Math.max(10, track.clientWidth / track.scrollWidth * 100) : 100;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (max > 4 ? (track.scrollLeft / max) * (100 / (w / 100) - 100) : 0) + '%)';
      }
      var prev = wrap.querySelector('.dp-bb-prev');
      var next = wrap.querySelector('.dp-bb-next');
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }

    root.querySelectorAll('[data-bb-scroller]').forEach(function (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          updateCarousel(carWrapper(track));
        });
      }, { passive: true });
    });

    /* ---------------- cart posting (dp-cart pipeline) ----------------
       A bare, fast cart/add.js POST (NO sections bundled in — that is the
       theme's slow path), then ONE ?sections= fetch applied through the
       patched xCartHelper.reRenderSections (dp-cart's surgical swap, with
       its own full-replace fallbacks). The theme's window.updatingCart
       mutex is respected on both sides so nothing races the drawer. */
    function shopRoot() {
      return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    }
    function sectionIds() {
      try {
        var ids = Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
        if (ids.length) return ids;
      } catch (e) {}
      return ['cart-drawer'];
    }
    function refreshDrawer() {
      /* fallback only — cache-busted so the edge can't serve a stale render */
      return fetch(shopRoot() + '?sections=' + sectionIds().join(',') + '&_=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          Alpine.store('xCartHelper').reRenderSections({ sections: sections });
        });
    }
    function openDrawer() {
      try {
        Alpine.store('xModal').setActiveElement('cart-icon');
        Alpine.store('xMiniCart').openCart();
      } catch (e) {}
    }
    function postItems(items, btn, onDone) {
      if (!items.length || (btn && btn.classList.contains('is-loading'))) return;
      if (btn) btn.classList.add('is-loading');

      function fail(err) {
        window.updatingCart = false;
        if (btn) btn.classList.remove('is-loading');
        var msg = root.querySelector('[data-bb-error]');
        if (msg) {
          msg.textContent = (err && err.message) || 'Could not add to cart';
          msg.hidden = false;
          setTimeout(function () { msg.hidden = true; }, 4000);
        }
        if (onDone) onDone(false);
      }

      function run() {
        window.updatingCart = true;
        fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          /* drawer sections requested IN the add POST: Shopify renders them
             in the same response as the mutation. The old follow-up GET
             could be served a stale pre-add render by the live storefront's
             edge cache — items then didn't show until a page refresh. */
          body: JSON.stringify({
            items: items,
            sections: sectionIds().join(','),
            sections_url: shopRoot()
          })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
          return r.json();
        }).then(function (data) {
          /* items are IN the cart from here — everything else is display */
          var map = data && data.sections;
          if (map && map['cart-drawer']) {
            /* fresh same-response HTML through the dp-cart surgical path */
            try { Alpine.store('xCartHelper').reRenderSections(map); return; } catch (e) {}
          }
          return refreshDrawer().catch(function () {
            /* drawer not injected yet or swap failed: theme recovery path */
            try { Alpine.store('xMiniCart').reLoad(); } catch (e) {}
          });
        }).then(function () {
          window.updatingCart = false;
          if (btn) btn.classList.remove('is-loading');
          try { document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); } catch (e) {}
          openDrawer();
          if (onDone) onDone(true);
        }).catch(fail);
      }

      /* respect the theme's cart mutex (max 2.5s, then proceed anyway) */
      var waited = 0;
      (function waitMutex() {
        if (!window.updatingCart || waited >= 2500) run();
        else { waited += 100; setTimeout(waitMutex, 100); }
      })();
    }

    /* ---- category tab row: flag it while there's still content off the right
       edge, so the CSS mask can fade it and the row reads as scrollable ---- */
    function syncTabOverflow() {
      var tabs = root.querySelector('.dp-bb-tabs');
      if (!tabs) return;
      tabs.classList.toggle(
        'dp-has-more',
        tabs.scrollLeft + tabs.clientWidth < tabs.scrollWidth - 1
      );
    }
    (function () {
      var tabs = root.querySelector('.dp-bb-tabs');
      if (!tabs) return;
      tabs.addEventListener('scroll', syncTabOverflow, { passive: true });
      window.addEventListener('resize', syncTabOverflow);
      syncTabOverflow();
    })();

    /* ---------------- events (one delegated listener) ---------------- */
    root.addEventListener('click', function (e) {
      var t;

      /* category tabs */
      if ((t = e.target.closest('.dp-bb-tab'))) {
        var i = t.getAttribute('data-tab-i');
        root.querySelectorAll('.dp-bb-tab').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        root.querySelectorAll('.dp-bb-panel').forEach(function (p) {
          p.hidden = p.getAttribute('data-panel-i') !== i;
        });
        /* A half-visible tab must not stay half-visible once it's the active
           one. Nudge the scroller itself rather than calling scrollIntoView,
           which would also scroll ancestors and jump the page vertically. */
        var row = t.parentElement;
        if (row && row.scrollWidth > row.clientWidth) {
          var rowBox = row.getBoundingClientRect();
          var tabBox = t.getBoundingClientRect();
          var pad = 12;
          var over = tabBox.right + pad - rowBox.right;
          var under = rowBox.left + pad - tabBox.left;
          if (over > 0) row.scrollLeft += over;
          else if (under > 0) row.scrollLeft -= under;
          syncTabOverflow();
        }
        applyVisibility();
        return;
      }

      /* sub-category chips */
      if ((t = e.target.closest('.dp-bb-chip'))) {
        var panel = t.closest('.dp-bb-panel');
        panel.querySelectorAll('.dp-bb-chip').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        applyVisibility();
        return;
      }

      /* card add / steppers */
      if ((t = e.target.closest('.dp-bb-add'))) {
        var card = t.closest('.dp-bb-card');
        bump(card.getAttribute('data-vid'), 1, itemFromCard(card));
        return;
      }
      if ((t = e.target.closest('[data-c-plus]'))) {
        bump(t.closest('.dp-bb-card').getAttribute('data-vid'), 1);
        return;
      }
      if ((t = e.target.closest('[data-c-minus]'))) {
        bump(t.closest('.dp-bb-card').getAttribute('data-vid'), -1);
        return;
      }

      /* rail rows */
      if ((t = e.target.closest('[data-r-plus]'))) {
        bump(t.closest('[data-vid]').getAttribute('data-vid'), 1);
        return;
      }
      if ((t = e.target.closest('[data-r-minus]'))) {
        bump(t.closest('[data-vid]').getAttribute('data-vid'), -1);
        return;
      }
      if ((t = e.target.closest('[data-r-remove]'))) {
        var vid = t.closest('[data-vid]').getAttribute('data-vid');
        delete state[vid];
        persist();
        renderRail();
        return;
      }

      /* carousel arrows (product tracks + prebuilt row) */
      if ((t = e.target.closest('.dp-bb-prev, .dp-bb-next'))) {
        var wrap = carWrapper(t);
        var track = wrap && wrap.querySelector('[data-bb-scroller]');
        if (!track) return;
        var cardEl = track.querySelector('.dp-bb-card:not([hidden]), .dp-bb-pb');
        var step = cardEl ? cardEl.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: t.classList.contains('dp-bb-prev') ? -step : step, behavior: 'smooth' });
        return;
      }

      /* filter drawer */
      if ((t = e.target.closest('[data-bb-filter-open]'))) { e.preventDefault(); syncFilterUI(); setFilterOpen(true); return; }
      if ((t = e.target.closest('[data-bb-fclose]'))) { setFilterOpen(false); return; }
      if ((t = e.target.closest('[data-bb-foverlay]'))) { setFilterOpen(false); return; }
      if ((t = e.target.closest('.dp-bb-fgroup-head'))) {
        var g = t.closest('.dp-bb-fgroup');
        var open = g.classList.contains('is-open');
        root.querySelectorAll('.dp-bb-fgroup').forEach(function (x) { x.classList.remove('is-open'); });
        if (!open) g.classList.add('is-open');
        return;
      }
      if ((t = e.target.closest('[data-bb-fapply]'))) {
        readFilterInputs();
        applyVisibility();
        setFilterOpen(false);
        return;
      }
      if ((t = e.target.closest('[data-bb-fclear]'))) {
        root.querySelectorAll('[data-bb-fdrawer] input').forEach(function (i) { i.checked = false; });
        readFilterInputs();
        applyVisibility();
        return;
      }

      /* pre-built bundles */
      if ((t = e.target.closest('.dp-bb-pb-view'))) {
        var pb = t.closest('.dp-bb-pb');
        pb.classList.add('is-open');
        /* the panel grows to the right — bring the FULL expanded card into
           frame. A one-shot smooth scroll clamps to the pre-expansion max
           (the row isn't wide enough yet), so we animate scrollLeft in step
           with the card's growth, re-clamping every frame. */
        var strip = pb.closest('[data-bb-scroller]');
        if (strip && strip.scrollWidth > strip.clientWidth + 4) {
          var sRect = strip.getBoundingClientRect();
          var cRect = pb.getBoundingClientRect();
          var leftInStrip = cRect.left - sRect.left + strip.scrollLeft;
          var target = leftInStrip + cRect.width + 232 + 16 - strip.clientWidth;
          var startLeft = strip.scrollLeft;
          if (target > startLeft) {
            var t0 = performance.now();
            var DUR = 460; /* a hair past the 380ms expansion */
            var easeS = function (p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; };
            var step = function (now) {
              var p = Math.min(1, (now - t0) / DUR);
              var desired = startLeft + (target - startLeft) * easeS(p);
              strip.scrollLeft = Math.min(desired, strip.scrollWidth - strip.clientWidth);
              if (p < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
        }
        return;
      }
      if ((t = e.target.closest('.dp-bb-pb-close'))) {
        t.closest('.dp-bb-pb').classList.remove('is-open');
        return;
      }
      if ((t = e.target.closest('.dp-bb-pb-use'))) {
        /* the card bows out and its items land in the side bundle cart */
        var pbEl = t.closest('.dp-bb-pb');
        if (pbEl.classList.contains('is-used')) return;
        var items = [];
        try { items = JSON.parse(pbEl.getAttribute('data-items') || '[]'); } catch (err) {
          console.warn('[dp-bundle] bad bundle data', err);
        }
        if (!items.length) return;
        items.forEach(function (i) {
          var vid = String(i.vid);
          if (state[vid]) {
            state[vid].qty = Math.min(state[vid].qty + i.qty, state[vid].cap || 99);
          } else {
            state[vid] = {
              qty: Math.min(i.qty, i.cap || 99),
              handle: '', title: i.title || '', meta: i.meta || '',
              price: i.price || 0, img: i.img || '', cap: i.cap || 99
            };
          }
        });
        persist();
        renderRail();
        pbEl.classList.add('is-used');
        setTimeout(function () { pbEl.style.display = 'none'; updateCarousel(carWrapper(pbEl)); }, 380);
        /* a beat after the card starts bowing out, then the sheet glides in —
           opening in the same instant as the tap read as an aggressive pop */
        if (window.innerWidth < 1024) setTimeout(function () { setRailOpen(true); }, 180);
        return;
      }

      /* add bundle to cart */
      if ((t = e.target.closest('[data-bb-atc]'))) {
        var list = Object.keys(state).map(function (vid) {
          return { id: +vid, quantity: state[vid].qty };
        });
        postItems(list, t, function (ok) {
          if (ok) {
            state = {};
            persist();
            renderRail();
            setRailOpen(false); /* mobile overlay yields to the cart drawer */
          }
        });
        return;
      }

      /* mobile mini bar -> rail overlay */
      if ((t = e.target.closest('[data-bb-mbar-view]'))) {
        setRailOpen(true);
        return;
      }
      if ((t = e.target.closest('[data-bb-railclose]'))) {
        setRailOpen(false);
        return;
      }
    });

    var railEl = root.querySelector('[data-bb-rail]');
    function setRailOpen(open) {
      if (!railEl) return;
      railEl.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('dp-bb-lock', open);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setFilterOpen(false); setRailOpen(false); }
    });

    /* the bar animates via transform now — the hidden attr only guards the
       pre-init flash */
    if (rail.bar) rail.bar.hidden = false;

    renderRail();
    applyVisibility();
    updateCarousel(root.querySelector('.dp-bb-pbwrap'));

    /* editorial hlines draw on scroll into view */
    if ('IntersectionObserver' in window) {
      root.setAttribute('data-bb-lines', '');
      var lio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            root.classList.add('is-lines-drawn');
            lio.disconnect();
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      lio.observe(root);

      /* mini bar visibility follows the section (slide, not pop) */
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          barInView = en.isIntersecting;
          if (rail.bar) rail.bar.classList.toggle('is-on', totalQty() > 0 && barInView);
        });
      }, { rootMargin: '80px 0px 80px 0px' });
      bio.observe(root);
    } else {
      barInView = true;
    }
  }

  window.__dpBundleBuilder = function () {
    document.querySelectorAll('[data-dp-bb]').forEach(init);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__dpBundleBuilder);
  } else {
    window.__dpBundleBuilder();
  }
  document.addEventListener('shopify:section:load', window.__dpBundleBuilder);
})();
